const es = {
  common: {
    play: 'Jugar',
    continue: 'Continuar',
    settings: 'Ajustes',
    back: 'Volver',
    retry: 'Repetir',
    exit: 'Salir',
    resume: 'Continuar',
    restart: 'Reiniciar nivel',
    exitToMenu: 'Salir al menú',
    locked: 'Bloqueado',
    close: 'Cerrar',
  },
  start: {
    title: 'NÉON',
    subtitle: 'Fluye. Adáptate. Sobrevive.',
  },
  worlds: {
    title: 'Selecciona un mundo',
    subtitle: 'Cada mundo es un nuevo estado de la materia',
    list: {
      w1: 'Arrecife del Origen',
      w2: 'Reino Helado',
      w3: 'Fuentes Termales',
      w4: 'Abismo',
      w5: 'Laboratorio Sumergido',
      w6: 'Reino de las Nubes',
    },
    unlocked: 'Desbloqueado',
  },
  level: {
    name: 'Arrecife del Origen — Nivel 1: El despertar',
    shortName: 'El despertar',
    volume: 'Volumen',
    drops: 'Gotas',
    pause: 'Pausa',
    checkpoint: 'Punto de flujo restaurado',
    victory: 'Nivel completado',
    defeat: 'El flujo se ha perdido',
    retryFromCheckpoint: 'Reintentar desde el punto seguro',
    remainingVolume: 'Volumen restante',
    dropsCollected: 'Gotas recogidas',
  },
  settings: {
    title: 'Ajustes',
    musicVolume: 'Volumen de música',
    effectsVolume: 'Volumen de efectos',
    vibration: 'Vibración',
    graphicsQuality: 'Calidad gráfica',
    low: 'Baja',
    medium: 'Media',
    high: 'Alta',
    touchControls: 'Controles táctiles',
    language: 'Idioma',
    on: 'Activado',
    off: 'Desactivado',
  },
  pause: {
    title: 'Pausa',
  },
};
export default es;
